import { tryParseJSON } from "@/components/shared/util";
import _ from "lodash";

function getItem(key: string, defaultValue: any) {
  return tryParseJSON(localStorage.getItem(key), defaultValue);
}
function setItem(key: string, value: any) {
  localStorage.setItem(key, JSON.stringify(value));
}
function removeItem(key: string) {
  localStorage.removeItem(key);
}

function mergeWithExisting(
  key: string,
  path: string,
  value: any,
  defaultValue: any
) {
  const valueInStore = getItem(key, defaultValue);
  if (valueInStore) {
    _.set(valueInStore, path, value);
  }
  setItem(key, valueInStore);
  return valueInStore;
}

export default {
  getItem,
  setItem,
  removeItem,
  mergeWithExisting
};
